exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resource-spacer[data-v-6a55137c] {\n  margin-bottom: .75rem;\n}\n", ""]);

// exports
